import { render, staticRenderFns } from "./ExpandToggleButton.vue?vue&type=template&id=1c9f0af6"
import script from "./ExpandToggleButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExpandToggleButton.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports